module.exports = __webpack_public_path__ + "img/sword.46b4b791.svg";